import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { IAppState } from '../../store/interface/app.state.interface';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { IUser } from '../../user/interfaces/user.interface';

@Injectable()
export class TenantGuard implements CanActivate {
    constructor(
        private store: Store<IAppState>,
        private router: Router,
        private messageService: MessageService,
    ) {}

    canActivate(): Observable<boolean | UrlTree> {
        return this.store
            .select((state) => state.user.loggedInUser)
            .pipe(
                map((user: IUser | null) => {
                    if (!user) {
                        return this.router.parseUrl('/');
                    }

                    if (!user.tenant?.id) {
                        this.messageService.add({
                            severity: 'warn',
                            summary: 'Tenant required',
                            detail: 'Please select a Tenant to access this page.',
                        });
                        return this.router.parseUrl('/');
                    }

                    return true;
                }),
            );
    }
}
